import { CodedProperty, stringArraysEqual } from "sprint-common-web";

import { MergeableVersion, validateVersionsMergeability } from "../../../common/utils/validateVersionsMergeability";
import { AncillaryItem } from "../AncillaryItem";

export const canBeAddedToMergeList = (ancillariesToMerge: AncillaryItem[], orphan: AncillaryItem): boolean => {
    if (orphan.merged) {
        return false;
    }

    if (!ancillariesToMerge.length) {
        return true;
    }

    if (ancillariesToMerge.length > 1) {
        return false;
    }

    const target = ancillariesToMerge[0];
    return (
        validAgainstCommonRules(target, orphan) &&
        oneHasBuzzId(target.buzz?.id, orphan.buzz?.id) &&
        hasMatchingAirlines(target.airlines, orphan.airlines)
    );
};

const validAgainstCommonRules = (target: AncillaryItem, orphan: AncillaryItem) => {
    const mappedTarget = mapToMergeabilityValidatorArg(target);
    const mappedOrphan = mapToMergeabilityValidatorArg(orphan);

    console.log({ mappedTarget, mappedOrphan });

    return validateVersionsMergeability([mappedTarget, mappedOrphan]);
};

const oneHasBuzzId = (chosenAncillaryToMergeBuzzId?: string, rowItemBuzzId?: string) => {
    return !!chosenAncillaryToMergeBuzzId !== !!rowItemBuzzId;
};

const hasMatchingAirlines = (chosenAncillaryAirlines: CodedProperty[], rowItemAirlines: CodedProperty[]) => {
    const chosenAncillaryAirlineIds = chosenAncillaryAirlines.map((airline: CodedProperty) => airline.id);
    const rowItemAirlineIds = rowItemAirlines.map((airline: CodedProperty) => airline.id);

    return stringArraysEqual(chosenAncillaryAirlineIds, rowItemAirlineIds);
};

const mapToMergeabilityValidatorArg = (ancillary: AncillaryItem): MergeableVersion => {
    const result: MergeableVersion = {
        /* for ancillary, unlike the other content types, we merge contents instead of versions */
        id: ancillary.id,
        mergedTargetId: ancillary.mergedTargetId
    };

    if (ancillary.versionBuzzId) {
        result.buzzVersion = {
            id: ancillary.versionBuzzId
        };
    }

    return result;
};
